import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PROPERTY_TYPES, COUNTRIES } from "@/lib/constants";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";

export const SearchBar = ({ className = "" }) => {
  const navigate = useNavigate();
  const { t } = useLang();
  const [f, setF] = useState({ transaction: "vente", type: "", country: "", city: "", min_price: "", max_price: "" });
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const TABS = [
    { value: "vente", label: t("search.buy") },
    { value: "location", label: t("search.rent") },
    { value: "investir", label: t("search.invest") },
  ];

  const submit = (e) => {
    e?.preventDefault();
    const params = new URLSearchParams();
    Object.entries(f).forEach(([k, v]) => { if (v) params.set(k, v); });
    const dest = f.transaction === "location" ? "/louer" : f.transaction === "investir" ? "/investir" : "/acheter";
    navigate(`${dest}?${params.toString()}`);
  };

  return (
    <form onSubmit={submit} data-testid="search-bar" className={`glass rounded-2xl p-4 sm:p-6 shadow-2xl border border-white/40 ${className}`}>
      <div className="flex gap-2 mb-4">
        {TABS.map((tab) => (
          <button key={tab.value} type="button" onClick={() => set("transaction", tab.value)}
            data-testid={`search-tab-${tab.value}`}
            className={`rounded-lg px-4 py-2 text-sm font-semibold transition-all ${f.transaction === tab.value ? "bg-navy text-white" : "bg-white/60 text-navy hover:bg-white"}`}>
            {tab.label}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
        <Select value={f.type} onValueChange={(v) => set("type", v)}>
          <SelectTrigger data-testid="search-type" className="bg-white"><SelectValue placeholder={t("search.type")} /></SelectTrigger>
          <SelectContent>{PROPERTY_TYPES.map((tp) => <SelectItem key={tp} value={tp}>{tp}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={f.country} onValueChange={(v) => set("country", v)}>
          <SelectTrigger data-testid="search-country" className="bg-white"><SelectValue placeholder={t("search.country")} /></SelectTrigger>
          <SelectContent>{COUNTRIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
        <Input data-testid="search-city" placeholder={t("search.city")} value={f.city} onChange={(e) => set("city", e.target.value)} className="bg-white" />
        <Input data-testid="search-min" type="number" placeholder={t("search.minBudget")} value={f.min_price} onChange={(e) => set("min_price", e.target.value)} className="bg-white" />
        <Input data-testid="search-max" type="number" placeholder={t("search.maxBudget")} value={f.max_price} onChange={(e) => set("max_price", e.target.value)} className="bg-white" />
      </div>
      <Button type="submit" data-testid="search-submit" className="mt-4 w-full sm:w-auto bg-gold text-navy hover:bg-gold-light font-semibold px-8 h-11 rounded-lg">
        <Search className="h-4 w-4 mr-2" /> {t("search.search")}
      </Button>
    </form>
  );
};
